<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist
			@help="help"
			@add="add"
			@reflash="reflash"
			@del="batchDel"
			ref="SetBtn"
		></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
			ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ShortName" :label="$t('getapi[2077]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="TypeName" :label="$t('getapi[1217]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')" width="100"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
						:confirmButtonText="$t('getapi[656]')"
						:cancelButtonText="$t('getapi[6]')"
						icon="el-icon-info"
						iconColor="red"
						:title="$t('getapi[637]')"
						@onConfirm="del(scope)"
					>
						<el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[2077]')}}</td>
					<td><el-input v-model="dataList._shortname" type="text" size="mini" ></el-input></td>
					<td>{{$t('getapi[1217]')}}</td>
					<td><el-input v-model="dataList._typename" type="text" size="mini" ></el-input></td>
                </tr>
				<tr>
                    <td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="dataList._remark" type="text" size="mini" ></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';

export default {
	name: 'transport',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			isVisible: false,
			DbTbNames: '', //表名
			userData: [],
			user: '',
			dataSet: [],
			dataList: {},
			PageIndex: 1,
			PageSize: this.$http.getPageSize('transport'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			queryData: [], // 查询数组
			selectIDData: [],
			ids: '',
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.user = that.userData.username;
		that.getView();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1111]"),this.$t("getapi[11]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.ReadOnlyRights('plv2', 97, 1)) {
				that.$refs.SetBtn.SetButtonEnable('refresh');
			}
			//操作权
			let ilimits = that.$limits.UnOperationAuthority('plv2', 97, 1);
			// limits说明：、2 编辑权限、3 删除权限
			switch (ilimits) {
				case 2:
					that.btn.edit = true;
					that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('create,save,refresh');
					break;
				case 3:
					that.btn.edit = true;
					that.btn.del = true;
					that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del');
					break;
				default:
                    that.$refs.SetBtn.SetButtonEnable('');
					break;
			}
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('transport',val)
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
			that.isVisible = true;
			that.dataList = {
				_exclusively_id: row.Exclusively_Id,
				_typename: row.TypeName,
				_shortname: row.ShortName,
				_showingid: 0,
				_remark: row.Remark,
				_issealed: row.isSealed
			};
		},
		// 获取数据
		getView() {
			let that = this;
			that.loading = true;
			that.$http.urlpost('/Basic/Sale/GetTransportTypeList', {}, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},
		// 保存数据
		save() {
			let that = this;
			that.loading = true;
			let parm = new Array();
			parm.push(that.dataList);
			console.log(parm);
			that.$http.urlpost('/Basic/Sale/SaveTransportType', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[284]'));
                    that.isVisible = false;
					that.getView();
				}
				that.loading = false;
			});
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
		},
		// 删除
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('/Basic/Sale/DeleteTransportTypeByID', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[659]'));
					that.getView();
				}
			});
		},
		// 删除
		del(row) {
			console.log(row);
			this.ids = row.row.Exclusively_Id + ',';
			this.delf();
		},
		//批量删除
		batchDel() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
			let that = this;
			that.isVisible = true;
			that.dataList = {
				_exclusively_id: 0,
				_typename: '',
				_shortname: '',
				_showingid: 0,
				_remark: '',
				_issealed: false
			};
		},
		// 刷新
		reflash() {
			this.getView();
		}
	}
};
</script>

<style lang="scss" scoped>
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
